/**
 * ファイルを新しいタブで開く
 * @param file URL または Fileオブジェクト
 */
export const openFileNewTab = (file) => {
    if (!file) {
        return;
    }
    // URL で指定されている場合
    if (typeof file === 'string') {
        window.open(file, '_blank');
        return;
    }
    // File オブジェクトの場合
    const blob = new Blob([file], { type: file.type });
    const fileURL = window.URL.createObjectURL(blob);
    window.open(fileURL, '_blank');
    window.URL.revokeObjectURL(fileURL);
};
